import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getCurrentMeet,
  getScreenMedia
} from 'selectors';

import { exportLifters } from 'util/exportData';
import { parseLifters } from 'util/importData';
import { addLifter } from 'util/pouchActions';

import Import from '../Import';
import ImportLiftersTable from './ImportLiftersTable';

class ImportLifters extends Component {

  render() {
    const {
      meet,
      media,
      onFinishBulkCreate
    } = this.props;

    return (
      <Import
        label={'Lifters'}
        meet={meet}
        addItem={addLifter}
        parseItems={parseLifters}
        exportItems={exportLifters}
        itemsTable={ImportLiftersTable}
        media={media}
        onFinishBulkCreate={onFinishBulkCreate} />
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    media: getScreenMedia(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(ImportLifters);
